export enum EValidate {
	REQUIRED = 'required',
}
export interface IValidate {
	[EValidate.REQUIRED](valor: any): boolean | string;
}
